<template id="Login">
    <v-ons-page id="LoginPage">
     <v-ons-row>
        <v-ons-col>
            <img src="../assets/img/logo.png" width="200px" style="margin:20px; padding-top:20px">
            <!-- <h3 class="entrar">Login</h3> -->
           
            <h3 class="textoCPF book">Insira seus dados para iniciar o jogo</h3>
            <label>Nome:</label>
            <!-- <v-ons-input  type="text" placeholder="Nome" v-model="input.strNome"></v-ons-input> -->
            <input type="text" class="text-input text-input--material inputMask" placeholder="NOME">
            <label>CPF:</label>
            <!-- <v-ons-input v-on:keyup.enter="makeLogin()" v-mask="'###.###.###-##'" placeholder="CPF" type="text" v-model="input.strCPF"></v-ons-input> -->
            <input type="text" class="text-input text-input--material inputMask" v-mask="'###.###.###-##'" v-model="input.strCPF" placeholder="CPF" v-on:keyup.enter="makeLogin()">
            <v-ons-button modifier="transparent" class="botao" @click="makeLogin()">Entrar</v-ons-button>
            
        </v-ons-col>
    </v-ons-row>
       
    </v-ons-page>
</template>
<style>

.entrar {
    font-size: 30px !important;
}
.facalogin {
    font-size: 19px;
    margin: 39px !important;
}
#LoginPage label {
    width: 80%;
    text-align: left;
    margin: 10px 30px;
    display: block;
}
ons-input { 
    margin-bottom:0px;
    background:#fff;
    width:80%;
}
#LoginPage .textoCPF {
    font-size: 19px !important;
    margin-bottom:30px !important;
}
#LoginPage .botao { 
    width:50%;
}
#LoginPage ons-input {
    display: inline-block;
    position: relative;
    width: 86%;
    margin-left:30px;
    margin-right:30px;
}
#LoginPage ons-input .text-input, ons-search-input .search-input {
    width: 100%;
    display: inline-block;
    height: 40px;
}
#LoginPage .inputMask {
    display: inline-block;
    position: relative;
    width: 86%;
    margin-left: 30px;
    margin-right: 30px;
    height: 40px;
    background-color: #fff;
}
#LoginPage ::placeholder {
    font-family: 'Roboto', 'Noto', sans-serif;
    font-size: 18px;
    font-weight: 400;
    padding-top: 4px;
    padding-left: 2px;
}
#LoginPage .text-input--material__label--active{
    display:none;
}
#LoginPage .list-item--material {
    border: 0;
    padding: 0 0 0 30px;
    line-height: normal;
}
#LoginPage .list-item--material__left {
    padding: 14px 0;
    min-width: 34px;
    line-height: 1;
    min-height: 48px;
}
#LoginPage a { 
    color:#ffff;
    text-decoration: underline;
}
#LoginPage .list-item--material__center { 
    background:none !important;
}
#LoginPage .text-input--material__label {
    
    -webkit-font-smoothing: antialiased;
    font-weight: 400;
    color: #afafaf;
    position: absolute;
    left: 2px;
    top: 2px;
    font-size: 18px;
    font-weight: 400;
    pointer-events: none;
    /* height: 66px; */
    padding-top: 4px;
}
</style>
<script>

import Quiz from './Quiz.vue';
export default {
    name: 'Login',
    key: 'Login',
    props: ['pageStack'],
    data(){ 
        return {
            input: {
                strNome: "",
                strCPF: "",
                flGeladeira: false,
                flVending: false
            }
        }
    },
    mounted() { 
        var i = localStorage.getItem("action")
        this.input.flGeladeira = i.flGeladeira
        this.input.flVending = i.flVending
    },
    methods: {
        makeLogin() {        
            if(this.input.dsNome != "" && this.input.dsCPF != "") {
                fetch(this.$hnk00_uri +'/cadastrar',
                    { method: "OPTIONS",
                    headers:  { "Content-Type": "application/json" },
                    body: JSON.stringify(this.input)})
                .then(response => response.json())
                .then(data => { 
                    
                    if (!isNaN(data)) {
                        localStorage.setItem("dsNome", this.input.strNome)
                        this.input = { strNome:"", strCPF:""}
                        localStorage.setItem("idCliente", data);   
                        localStorage.setItem("makeLogin", true);
                        this.$emit("pop")
                        this.$emit("push",Quiz)
                    }
                })
                .catch(error => 
                    {
                        if (error) {
                        this.$ons.notification.toast("Combinação Email e Senha inválida! ", { timeout: 1000, animation: 'ascend' });
                        localStorage.setItem("fetchErr", error);
                        }
                    });
            } else {
                this.$ons.notification.toast("Por favor insira um Email e uma Senha!", { timeout: 1000, animation: 'ascend' })
            }
        },
        back (){ 
            this.$emit('pop');
        }
    }
}
</script>